export default __webpack_public_path__ + "static/media/home-11.df627322.jpg";